import React from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../routes';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: '#f5f5f5',
  borderBottom: '1px solid #e0e0e0',
  '& .MuiTab-root': {
    minHeight: '48px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    '&.Mui-selected': {
      color: '#064d51',
      backgroundColor: 'rgba(192, 242, 243, 0.3)',
      borderBottom: '3px solid #064d51',
    },
  },
}));

const DashboardSelector = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine which tab is active based on the current path
  const getCurrentTab = () => 0; // Only Document Services tab
  
  const handleTabChange = () => {
    // Always keep on Document Services; ensure route points to documents
    if (!location.pathname.includes('/documents')) {
      navigate(ROUTES.CUSTOMER.DASHBOARD.DOCUMENTS);
    }
  };
  
  return (
    <Paper elevation={0}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <StyledTabs
          value={getCurrentTab()}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
        >
          <Tab label="Document Services" />
        </StyledTabs>
      </Box>
    </Paper>
  );
};

export default DashboardSelector;
